export function getDateStr(date, yearOffset = 0, monthOffset = 0, dayOffset = 0) {
  const d = new Date(date);
  d.setHours(d.getHours() + 8);
  d.setDate(d.getDate() + dayOffset);
  d.setMonth(d.getMonth() + monthOffset);
  d.setFullYear(d.getFullYear() + yearOffset);
  return d.toISOString().slice(0, 10).replace(/-/g, '/');
}

export function getDateStrArr(date) {
  const d = new Date(date);
  d.setDate(1);
  return [getDateStr(d), getDateStr(d, 0, 1)];
}

export function getDateAndTimeStr(date) {
  const d = new Date(date);
  d.setHours(d.getHours() + 8);
  const e = d.toISOString().split('T');
  return `${e[0]}\n${e[1].split('.')[0]}`;
}

export function getMonthStr() {
  const d = new Date(date);
  d.setHours(d.getHours() + 8);
  return d.toISOString().slice(0, 7).replace(/-/g, '/');
}
